module.exports = __webpack_public_path__ + "static/media/enfant-attendu.2b8a6d63.svg";